// CRM 2.0 Cancellation card — Cancellations tab (M1-F10). Drawn as prototype card4:
// status chip, where it came from · stage, Extended N×, reprice / waived chips, name and
// lead id, Raised · reason, Paid, Charges or Refund, and the cancellation tracker.
// The ⋮ menu items come from Crm2Page; approve / extend buttons come with the cancellation module.
import React from "react";
import css from "../ui/Crm2Cards.module.css";
import CardMessage from "../ui/CardMessage";
import CardMenu from "../ui/CardMenu";
import { Bars, Chip, inr, lid, unitLine } from "../ui/cardParts";

const num = (v) => Number(v) || 0;
const fmtShort = (ms) => (ms ? new Date(Number(ms)).toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) : "");

const isAgreementStage = (x) => ["OVERDUE_AGREEMENT_DAYS", "CRM_RAISED_AGREEMENT", "CANCELLED_IN_FARVISION"].includes(x.source);

function tracker(x) {
  const s2 = isAgreementStage(x);
  const custOk = x.source === "CUSTOMER_ASKED" || x.source === "CRM_RAISED" || x.source === "CRM_RAISED_AGREEMENT";
  const ord = s2 ? ["WAITING_CUSTOMER_OK|WITH_CRM", "WITH_CRM_HEAD", "CANCELLING_IN_FARVISION", "CANCELLED"] : ["WAITING_CUSTOMER_OK|WITH_CRM", "WITH_CRM_HEAD", "CANCELLED"];
  const o = ord.findIndex((k) => k.split("|").includes(x.stage));
  const refd = x.stage === "CANCELLED" && x.refundStatus === "DONE";
  const first = custOk ? "Customer OK" : "You";
  return s2
    ? [["Raised", 2], [first, o > 0 ? 2 : 1], ["CRM Head", o > 1 ? 2 : o === 1 ? 1 : 0], ["FarVision", o > 2 ? 2 : o === 2 ? 1 : 0], ["Unit released", o > 2 ? 2 : 0], ["Refunded", refd ? 2 : o > 2 ? 1 : 0]]
    : [["Raised", 2], [first, o > 0 ? 2 : 1], ["CRM Head", o > 1 ? 2 : o === 1 ? 1 : 0], ["Unit released", o > 1 ? 2 : 0], ["Refunded", refd ? 2 : o > 1 ? 1 : 0]];
}

function Kv({ k, v, red }) {
  return (
    <div className={css.r}>
      <span>{k}</span>
      <span style={{ color: red ? "#B42318" : "#101828", textAlign: "right" }}>{v}</span>
    </div>
  );
}

export default function Crm2CancellationCard({ card: c, menu, onMenu }) {
  const x = c.cancel || {};
  const [st, sc] = c.cancelStatus || ["", "c-lt"];
  const [from, stage] = c.cancelFrom || ["", ""];
  const done = x.stage === "CANCELLED";
  const s2 = isAgreementStage(x);
  const auto = /^OVERDUE/.test(x.source || "");
  const notDone = Array.isArray(x.notDoneSteps) ? x.notDoneSteps.join(", ") : "";
  const why = auto ? `Not done: ${notDone}` : x.reason || "";
  const paid = num(c.paidAmt?.ocr) + num(c.paidAmt?.gst) + num(c.paidAmt?.sdr);
  const ch = x.charges || {};
  const extensions = Array.isArray(x.extensions) ? x.extensions.length : 0;
  const reprice = x.isSkipReprice ? "Reprice Skipped" : x.unitPriceAlreadyUpdated ? "Reprice Done" : "Reprice Pending";
  return (
    <div className={css.card}>
      <div className={css.cardH}>
        <div className={css.col}>
          <p className={css.u}>{unitLine(c)}</p>
          <div className={css.row} style={{ gap: ".8rem" }}>
            <Chip text={st} tone={sc} />
            <Chip text={`${from}${stage ? ` · ${stage}` : ""}`} tone={/Overdue/.test(from) ? "c-err" : "c-lt"} dot={false} />
            {extensions > 0 && <Chip text={`Extended ${extensions}×`} tone="c-warn" dot={false} />}
            {done && <Chip text={reprice} tone={x.isSkipReprice || x.unitPriceAlreadyUpdated ? "c-ok" : "c-warn"} dot={false} />}
            {x.isWaivedOff && <Chip text="Cancellation Charges Waived" tone="c-lt" dot={false} />}
          </div>
        </div>
        <CardMenu items={menu} onPick={onMenu} />
      </div>
      <div className={css.row} style={{ alignItems: "baseline", gap: ".5rem" }}>
        <p className={css.u}>{c.leadName}</p>
        <p className={css.lid}>{lid(c.leadDisplayId)}</p>
      </div>
      <div className={css.meta}>
        <Kv k={`Raised ${fmtShort(x.raisedAt)}`} v={why} red={auto} />
        <Kv k="Paid" v={inr(paid) + (num(c.paidAmt?.sdr) ? " (incl. SDR)" : "")} />
        <Kv
          k={s2 ? "Charges" : "Refund"}
          v={
            x.refund?.noRefund
              ? "Accepted without refund"
              : s2
                ? `${inr(ch.amount ?? x.cancellationCharges)}${x.isWaivedOff ? " (waived)" : ""} · refund ${inr(ch.refundTotal ?? paid - num(ch.amount ?? x.cancellationCharges))}`
                : `${inr(paid)} · no charges`
          }
        />
      </div>
      <Bars steps={tracker(x)} />
      {c.message && (
        <div className={css.cardF}>
          <CardMessage message={c.message} />
        </div>
      )}
    </div>
  );
}
